module.exports = __webpack_public_path__ + "img/BNTY.bdf348b0.svg";